import useActiveCursor from '@/hooks/useActiveCursor.js';
import { useCallback, useRef } from 'react';
import Button from './Button.jsx';
import IconV2 from './v2/IconV2.jsx';

const ToggleButton = ({ options, value, fullWidth = true, size = 'md', onChange, pill = false, centered = false, disabled = false, className = '', noWrap = false }) => {
  const containerRef = useRef(null);

  const itemLabels = options?.map((n) => n.label)?.join(',');
  const activeIndex = options?.findIndex((option) => option.value === value);
  const cursorStyle = useActiveCursor({ activeIndex, containerRef, offset: 0 }, [itemLabels]);

  const handleClick = useCallback(
    (e, option) => {
      if (disabled) {
        return;
      }
      onChange(option?.value);
    },
    [disabled, onChange]
  );

  return (
    <div className={`comp-toggle-button ${fullWidth ? 'full-width' : ''} size-${size} ${pill ? 'pill' : ''} ${centered ? 'centered' : ''} ${disabled ? 'disabled' : ''} ${className}`}>
      <div className={`comp-toggle-button-container ${noWrap ? 'no-wrap' : ''}`} ref={containerRef}>
        {options?.map((option, idx) => (
          <Button key={idx} data-active={option.value === value} size={size} title={option?.title} className={`${fullWidth ? 'full-width' : ''} filled medium ${pill ? 'pill' : ''}`} onClick={(e) => handleClick(e, option)} icon={option?.icon && <IconV2 icon={option?.icon} {...(option?.iconProps || {})} />} {...(option?.props || {})} disabled={disabled}>
            {option?.label}
          </Button>
        ))}
        <div className="comp-toggle-button-active-cursor" style={cursorStyle} />
      </div>
    </div>
  );
};

export default ToggleButton;
